module.exports = __webpack_public_path__ + "static/media/thum4.f6408939.jpg";